import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteWithToken, getLocalStorage, getWithToken, patchWithPdf, patchWithToken, postWithToken } from '../API/Api';
import Loader from '../components/Loader';
import SCANURL_ACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/scan-url-activeicon.svg';
import SCANURL_DEACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/scan-url-deactiveicon.svg';
import UPLOAD_ACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/upload-activeicon.svg';
import UPLOAD_DEACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/upload-deactiveicon.svg';
import TEXT_ACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/text-activeicon.svg';
import TEXT_DEACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/text-deactiveicon.svg';
import ADDPRODUCT_ACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/addproduct-activeicon.svg';
import ADDPRODUCT_DEACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/addproduct-deactiveicon.svg';
import SAVE_ICON from '../assets/icons/ComniqaiIcon-V3.0/save-icon.svg';
import moment from 'moment';
import { IoCheckmarkDoneSharp } from 'react-icons/io5';
import { MdOutlineUploadFile } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { FiUpload } from 'react-icons/fi';
import { FaRegFilePdf } from 'react-icons/fa';
import { HiOutlineDocument } from 'react-icons/hi2';
import { BiGlobe } from 'react-icons/bi';
import CustomPopUp from '../components/CustomPopUp';
import SubContext from '../contexts/SubContext';
import useProgress from '../hooks/useProgress';
import { ChevronDown, ChevronUp, X } from 'lucide-react';
import ButtonLoader from '../components/ButtonLoader';

const actions = [
  { label: 'Scan URL', activeIcon: SCANURL_ACTIVEICON, deActiveIcon: SCANURL_DEACTIVEICON, activeStep: '1' },
  { label: 'Upload File', activeIcon: UPLOAD_ACTIVEICON, deActiveIcon: UPLOAD_DEACTIVEICON, activeStep: '2' },
  { label: 'Enter Text', activeIcon: TEXT_ACTIVEICON, deActiveIcon: TEXT_DEACTIVEICON, activeStep: '3' },
  { label: 'Add Products', activeIcon: ADDPRODUCT_ACTIVEICON, deActiveIcon: ADDPRODUCT_DEACTIVEICON, activeStep: '4' },
];
const WebsiteScrape = ({ refreshUserProfile }) => {
  const Navigate = useNavigate();
  const { startPolling } = useProgress();
  const subsFlag = useContext(SubContext);
  const [activeTab, setActiveTab] = useState('1');
  const [scan_url, setScan_url] = useState('');
  const [urlList, setUrlList] = useState([]);
  const [apiTokenData, setApiTokenData] = useState('');
  const [loader, setLoader] = useState(false);
  const [selectedScanUrl, setSelectedScanUrl] = useState([]);
  const [displayContinue, setDisplayContinue] = useState(false);
  const [selectAllData, setSelectAllData] = useState(false);
  const [scaning, setScaning] = useState(false);
  const [addText, setAddText] = useState('');
  const [websiteAndPdfs, setWebsiteAndPdfs] = useState('');

  const [deleteAllWebsiteAndPdfs, setDeleteAllWebsiteAndPdfs] = useState(false);
  const [deleteWebsiteAndPdfs, setDeleteWebsiteAndPdfs] = useState(false);
  const [selectedWebsiteAndPdfs, setSelectedWebsiteAndPdfs] = useState({ id: null, type: null });
  const [productPrice, setProductPrice] = useState(null);
  const [botId, setBotId] = useState('');

  const [progress, setProgress] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [scanType, setScanType] = useState('website');
  const [advancedOptions, setAdvancedOptions] = useState({
    includePaths: [],
    excludePaths: [],
  });
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [includeInput, setIncludeInput] = useState('');
  const [excludeInput, setExcludeInput] = useState('');

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setApiTokenData(JSON.parse(token));
      handleGetText(JSON.parse(token));
      fetchWebsiteAndPdfs(JSON.parse(token));
      getBotDetails(JSON.parse(token));
    } else {
      Navigate('/login');
    }
  }, []);

  useEffect(() => {
    // Reset values when scanType changes
    setUrlList([]);
    setDisplayContinue(false);
    setScan_url('');
    setAdvancedOptions({
      includePaths: '',
      excludePaths: '',
    });
    setSelectedScanUrl([]);
  }, [scanType]);

  const companyHandleChange = (e) => {
    setSelectedScanUrl([]);
    setScan_url(e.target.value);
    // Reset advanced options when URL changes
    setAdvancedOptions({
      includePaths: '',
      excludePaths: '',
    });
  };
  const handleAdvancedOptionsChange = (field, value) => {
    setAdvancedOptions((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle adding tags on Enter or comma
  const handleIncludeKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const value = includeInput.trim();
      if (value && !advancedOptions?.includePaths.includes(value)) {
        setAdvancedOptions((prev) => ({
          ...prev,
          includePaths: [...prev.includePaths, value],
        }));
        setIncludeInput('');
      }
    } else if (e.key === 'Backspace' && !includeInput && advancedOptions?.includePaths.length > 0) {
      // Remove last tag on backspace when input is empty
      setAdvancedOptions((prev) => ({
        ...prev,
        includePaths: prev.includePaths.slice(0, -1),
      }));
    }
  };

  const handleExcludeKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const value = excludeInput.trim();
      if (value && !advancedOptions.excludePaths.includes(value)) {
        setAdvancedOptions((prev) => ({
          ...prev,
          excludePaths: [...prev.excludePaths, value],
        }));
        setExcludeInput('');
      }
    } else if (e.key === 'Backspace' && !excludeInput && advancedOptions.excludePaths.length > 0) {
      setAdvancedOptions((prev) => ({
        ...prev,
        excludePaths: prev.excludePaths.slice(0, -1),
      }));
    }
  };

  // Remove individual tags
  const removeIncludePath = (pathToRemove) => {
    setAdvancedOptions((prev) => ({
      ...prev,
      includePaths: prev.includePaths.filter((path) => path !== pathToRemove),
    }));
  };

  const removeExcludePath = (pathToRemove) => {
    setAdvancedOptions((prev) => ({
      ...prev,
      excludePaths: prev.excludePaths.filter((path) => path !== pathToRemove),
    }));
  };

  const getBotDetails = (token) => {
    setLoader(true);
    getWithToken('company/', token)
      .then((response) => {
        if (response.status === 201) {
          setBotId(response?.data?.id);
          setProductPrice(response?.data?.product_price);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      })
      .finally(() => {
        setLoader(false); // always executes
      });
  };

  const getUrlListData = (ScanUrl, token) => {
    if (!ScanUrl) {
      toast.error('Enter website URL');
      return;
    }

    setUrlList([]);
    setSelectAllData(false);
    setSelectedScanUrl([]);
    setScaning(true);
    setProgress(10);

    let progressValue = 10;

    const progressInterval = setInterval(() => {
      if (progressValue < 90) {
        progressValue += 5;
        setProgress(progressValue);
      }
    }, 300);

    const payload = { [scanType === 'website' ? 'website_url' : 'sitemap_url']: ScanUrl };

    // Add advanced options with safety checks
    if (Array.isArray(advancedOptions.includePaths) && advancedOptions.includePaths.length > 0) {
      payload.include_paths = advancedOptions.includePaths.join(',');
    }

    if (Array.isArray(advancedOptions.excludePaths) && advancedOptions.excludePaths.length > 0) {
      payload.exclude_paths = advancedOptions.excludePaths.join(',');
    }

    postWithToken('Knowledge_baseURLAPI', token, payload)
      .then((response) => {
        let urlData = [];
        if (response.status === 200) {
          response?.data.forEach((element) => {
            urlData.push({
              data: element.url,
              checked: element.scan,
              disableChecked: element.scan,
            });
          });
          setScaning(false);
          setUrlList(urlData);
          setDisplayContinue(true);
          if (response.message) toast.success(response.message);
        } else {
          toast.error(response?.message);
          setScaning(false);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
        toast.error('Something went wrong');
      })
      .finally(() => {
        clearInterval(progressInterval);
        setTimeout(() => {
          setProgress(100);
          setTimeout(() => setProgress(0), 1000);
        }, 300);
        setScaning(false);
      });
  };

  const onChangeofScan = (e, index) => {
    const checked = e.target.checked;
    const value = e.target.value;

    // Skip if item is disabled
    if (urlList[index]?.disableChecked) return;

    // Update urlList
    const newUrlList = urlList.map((item, i) => (i === index ? { ...item, checked } : item));
    setUrlList(newUrlList);

    // Update selectedScanUrl (ignore disableChecked items)
    if (checked) {
      setSelectedScanUrl((prev) => [...prev, { value, index }]);
    } else {
      setSelectedScanUrl((prev) => prev.filter((item) => item.index !== index));
    }

    // Update selectAllData automatically (only for selectable items)
    const selectableItems = newUrlList.filter((item) => !item.disableChecked);
    const allChecked = selectableItems.every((item) => item.checked);
    setSelectAllData(allChecked);
  };

  // ✅ Select All (only selectable items)
  const handleSelectAllData = () => {
    setSelectAllData(true);

    const newUrlList = urlList.map((item) => (item.disableChecked ? item : { ...item, checked: true }));
    setUrlList(newUrlList);

    const selectedData = urlList
      .filter((item) => !item.disableChecked)
      .map((item, index) => ({
        value: item.data,
        index,
      }));

    setSelectedScanUrl(selectedData);
  };

  // ✅ Deselect All (only selectable items)
  const handleDeSelectAllData = () => {
    setSelectAllData(false);

    const newUrlList = urlList.map((item) => (item.disableChecked ? item : { ...item, checked: false }));
    setUrlList(newUrlList);

    setSelectedScanUrl([]);
  };

  const submitScanData = () => {
    if (selectedScanUrl.length === 0) {
      toast.error('Select minimum 1 URL');
      return;
    }

    setLoader(true);

    const sendUrlData = selectedScanUrl.map((data) => data.value);
    const obj = { url_links: sendUrlData };

    postWithToken('KB_questionsURLAPI', apiTokenData, obj)
      .then((response) => {
        if (response.status === 200) {
          const taskId = response.task_id;
          localStorage.setItem('activeTaskId', taskId);
          startPolling(apiTokenData, taskId);
          setLoader(false);
          Navigate('/chatbot?tab=faqs');
          toast.success(response.message);
          refreshUserProfile();
          subsFlag.setUpdateValue('1');
        } else if (response.status === 504) {
          toast.error('Extracting knowledge base in the background, you may proceed.');
        } else {
          toast.dismiss();
          toast.error(response.message);
        }
      })
      .catch(() => {
        toast.error('Something went wrong');
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleGetText = (token) => {
    getWithToken('Text_questionsURLAPI', token)
      .then((response) => {
        if (response.status === 200) {
          setAddText(response?.data);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      });
  };

  const handleAddText = () => {
    const obj = {
      text: addText,
    };
    patchWithToken('Text_questionsURLAPI', apiTokenData, obj)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message);
          subsFlag.setUpdateValue('1');
        } else if (response.status === 400) {
          toast.error(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleSelectFile = async (e) => {
    const selectedFiles = Array.from(e.target.files);
    const pdfFiles = selectedFiles.filter((file) => file.type === 'application/pdf');

    if (!pdfFiles.length) {
      toast.error('Please select only PDF files.');
      return;
    }

    setUploadedFiles(pdfFiles);
    await patchUploadPdf(pdfFiles, apiTokenData);
  };

  const patchUploadPdf = async (files, token) => {
    if (files && files.length) {
      let fd = new FormData();
      files.forEach((file) => fd.append('pdf', file));

      setProgress(10);

      let progressValue = 10;
      const progressInterval = setInterval(() => {
        if (progressValue < 90) {
          progressValue += 5;
          setProgress(progressValue);
        }
      }, 300);

      try {
        const response = await patchWithPdf('PDF_questionsURLAPI', token, fd);
        if (response.status === 200) {
          toast.success(response.message);
          setUploadedFiles([]);
          fetchWebsiteAndPdfs(apiTokenData);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error(error);
        toast.error('Something went wrong during upload.');
      } finally {
        setUploadedFiles([]);
        clearInterval(progressInterval);
        setTimeout(() => {
          setProgress(100);
          setTimeout(() => {
            setProgress(0);
          }, 800);
        }, 300);
      }
    }
  };

  const fetchWebsiteAndPdfs = (token) => {
    getWithToken('website-and-pdfs', token)
      .then((response) => {
        if (response.status === 200) {
          setWebsiteAndPdfs(response?.data);
          subsFlag.setUpdateValue('1');
        }
      })
      .catch((error) => {
        console.error('Error fetching website-and-pdfs:', error);
      });
  };

  const handleUploadedDelete = async (id, type) => {
    try {
      setLoader(true);
      const response = await deleteWithToken(`website-and-pdfs?type=${type}&id=${id}`, apiTokenData);
      if (response.status === 200) {
        fetchWebsiteAndPdfs(apiTokenData);
        toast.success(response.message);
        setDeleteWebsiteAndPdfs(false);
      } else if (response.status === 400) {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const countCharacters = (text) => {
    if (text) {
      const trimmedText = text.trim();
      return trimmedText.length;
    }
  };

  const companyHandleClick = async () => {
    setLoader(true);

    const apiCall = botId
      ? patchWithToken(`company/${botId}/`, apiTokenData, { product_price: productPrice })
      : postWithToken('company/', apiTokenData, { product_price: productPrice });

    try {
      const response = await apiCall;

      if (response.status === 200 || response.status === 201) {
        getBotDetails(apiTokenData);
        toast.success(response.message);
        subsFlag.setUpdateValue('1');
      } else if (response) {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error('Something went wrong');
    } finally {
      setLoader(false);
    }
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
  };

  const handleDeleteAllWebsiteAndPdfs = async () => {
    try {
      setLoader(true);
      const response = await deleteWithToken('delete_all_pdf_url', apiTokenData);

      if (response.status === 200) {
        toast.success('All Website and PDFs have been successfully deleted.');
        setDeleteAllWebsiteAndPdfs(false);
        fetchWebsiteAndPdfs(apiTokenData);
      } else if (response.status === 400) {
        toast.error(response.message || 'Bad Request');
      } else {
        toast.error('Unexpected response from server');
      }
    } catch (error) {
      console.error('Delete failed:', error);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <div className='comniq-container'>
        <div className='knowledge-hub p-4'>
          <div className='knowledge-hub__header mb-4'>
            <h5 className='knowledge-hub__title outfit-bold'>Knowledge Hub</h5>
            <p className='knowledge-hub__subtitle text-muted mb-0 outfit-regular'>Add knowledge sources to train the bot</p>
          </div>

          <div className='knowledge-hub__actions d-flex gap-3 flex-wrap mb-4'>
            {actions.map((action, idx) => (
              <div
                key={idx}
                onClick={() => setActiveTab(action.activeStep)}
                className={`knowledge-hub__action-box text-center p-3 rounded-4 ${activeTab === action.activeStep ? 'active' : ''}`}
              >
                <div className='knowledge-hub__icon d-flex align-items-center justify-content-center mb-2 rounded-3'>
                  <img src={activeTab === action.activeStep ? action.activeIcon : action.deActiveIcon} alt={`${action.label}-icon`} style={{ width: '25px', height: '25px' }} />
                </div>
                <span className='outfit-medium'>{action.label}</span>
              </div>
            ))}
          </div>

          {activeTab === '1' && (
            <>
              {/* Scan Type Selector */}
              <div className='d-flex gap-4 align-items-center mb-3'>
                <label className='form-check outfit-medium font14'>
                  <input type='radio' name='scanType' value='website' checked={scanType === 'website'} onChange={() => setScanType('website')} className='form-check-input me-2' />
                  Website URL
                </label>
                <label className='form-check outfit-medium font14'>
                  <input type='radio' name='scanType' value='sitemap' checked={scanType === 'sitemap'} onChange={() => setScanType('sitemap')} className='form-check-input me-2' />
                  Sitemap URL
                </label>
              </div>
              <div className='knowledge-hub__input-group d-flex align-items-center'>
                <input
                  type='text'
                  className='form-control knowledge-hub__input me-3 px-4'
                  // placeholder='Enter website URL'
                  placeholder={scanType === 'website' ? 'https://www.example.com' : 'https://www.example.com/sitemap.xml'}
                  value={scan_url}
                  onChange={companyHandleChange}
                  disabled={displayContinue}
                />
                <button
                  className={`chatbot-save-btn ${scaning && 'dot-loading d-flex justify-content-center align-items-center'}`}
                  onClick={() => getUrlListData(scan_url, apiTokenData)}
                  disabled={scaning}
                >
                  {scaning ? 'Scanning' : 'Scan'}
                </button>
              </div>
              {/* Advanced Options Accordion */}
              <div className='advanced-options mb-4'>
                <button type='button' className='advanced-options__toggle' onClick={() => setShowAdvanced(!showAdvanced)}>
                  {showAdvanced ? <ChevronUp size={18} className='advanced-options__icon' /> : <ChevronDown size={18} className='advanced-options__icon' />}
                  <span className='outfit-medium font14'>Advanced options</span>
                </button>

                <div className={`advanced-options__content ${showAdvanced ? 'advanced-options__content--open' : ''}`}>
                  <div className='advanced-options__inner'>
                    <div className='row'>
                      {/* Include Paths */}
                      <div className='col-md-6'>
                        <div className='chatbox-input-text input-GPT new'>
                          <label className='outfit-medium'>Include only paths</label>
                          <div className='chatbox-input-field'>
                            <div className='tags-input'>
                              <div className='tags-input__container'>
                                {Array.isArray(advancedOptions.includePaths) &&
                                  advancedOptions.includePaths.map((path, index) => (
                                    <span key={index} className='tags-input__badge outfit-medium'>
                                      {path}
                                      <button type='button' className='tags-input__remove' onClick={() => removeIncludePath(path)} aria-label='Remove tag'>
                                        <X />
                                      </button>
                                    </span>
                                  ))}
                                <input
                                  type='text'
                                  className='tags-input__field'
                                  placeholder={(advancedOptions.includePaths?.length || 0) === 0 ? 'Ex: blog/*, dev/*' : ''}
                                  autoComplete='off'
                                  value={includeInput}
                                  onChange={(e) => setIncludeInput(e.target.value)}
                                  onKeyDown={handleIncludeKeyDown}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Exclude Paths */}
                      <div className='col-md-6'>
                        <div className='chatbox-input-text input-GPT new'>
                          <label className='outfit-medium'>Exclude paths</label>
                          <div className='chatbox-input-field'>
                            <div className='tags-input'>
                              <div className='tags-input__container'>
                                {Array.isArray(advancedOptions.excludePaths) &&
                                  advancedOptions.excludePaths.map((path, index) => (
                                    <span key={index} className='tags-input__badge outfit-medium'>
                                      {path}
                                      <button type='button' className='tags-input__remove' onClick={() => removeExcludePath(path)} aria-label='Remove tag'>
                                        <X />
                                      </button>
                                    </span>
                                  ))}
                                <input
                                  type='text'
                                  className='tags-input__field'
                                  placeholder={(advancedOptions.excludePaths?.length || 0) === 0 ? 'Ex: blog/*, dev/*' : ''}
                                  autoComplete='off'
                                  value={excludeInput}
                                  onChange={(e) => setExcludeInput(e.target.value)}
                                  onKeyDown={handleExcludeKeyDown}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {activeTab === '1' && urlList.length > 0 && (
            <div className='scanner-container py-4'>
              {progress > 0 && (
                <div className='mb-3'>
                  <label className='form-label fw-semibold'>Scanning progress</label>
                  <div className='progress rounded-pill' style={{ height: '6px' }}>
                    <div
                      className='progress-bar bg-primary'
                      role='progressbar'
                      style={{ width: `${progress}%` }}
                      aria-valuenow={progress}
                      aria-valuemin='0'
                      aria-valuemax='100'
                    ></div>
                  </div>
                  <div className='text-end small fw-semibold text-primary mt-1'>{progress}%</div>
                </div>
              )}
              <div className='d-flex justify-content-between align-items-center mb-3'>
                <div className='d-flex align-items-center gap-2'>
                  <img src={TEXT_DEACTIVEICON} alt='scanurl-icon' className='' />
                  <h6 className='mb-0 outfit-medium'>Scanned Pages</h6>
                </div>

                {displayContinue && (
                  <div className='d-flex align-items-center gap-3'>
                    <button className='scan-url-button outfit-regular' onClick={() => submitScanData()}>
                      Add URLs to Knowledge Hub
                    </button>
                  </div>
                )}
              </div>
              {displayContinue && (
                <div className='d-flex align-items-center gap-3'>
                  <div className='checkbox-box ps-3'>
                    <div className='form-check custom-round-checkbox'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        id='selectToggle'
                        checked={selectAllData}
                        onChange={() => (selectAllData ? handleDeSelectAllData() : handleSelectAllData())}
                      />
                      <label className='form-check-label outfit-regular' htmlFor='selectToggle'>
                        {selectAllData ? 'Deselect All' : 'Select All'}
                      </label>
                    </div>
                  </div>
                  <div className='outfit-regular'>
                    Selected URLs: <strong>{selectedScanUrl.length}</strong>
                  </div>
                </div>
              )}
              <div className='scanned-pages-list'>
                {urlList.map((row, i) => (
                  <div className='list-group scanned-pages'>
                    <div className='list-group-item d-flex justify-content-between align-items-center border-0 py-3'>
                      <div className='d-flex align-items-center justify-content-between w-100 gap-2'>
                        <div className='d-flex align-items-center custom-round-checkbox gap-2 w-100'>
                          <input
                            type='checkbox'
                            id={i + 1}
                            name='i'
                            disabled={row?.disableChecked}
                            onChange={(e) => onChangeofScan(e, i)}
                            value={row.data}
                            checked={row?.checked}
                          />
                          <label for={i + 1}></label>
                          <span className='text-muted small'>Page {i + 1} of</span>
                          <a
                            href={row?.data}
                            className={`text-decoration-none text-primary outfit-medium ${row?.disableChecked ? 'scrapeSelected' : 'noScrapeSelected'}`}
                            target='_blank'
                            rel='noreferrer'
                            style={{ opacity: row?.disableChecked ? '0.5' : '1', wordBreak: 'break-all' }}
                          >
                            {row?.data}
                          </a>
                        </div>
                        {row?.disableChecked && <IoCheckmarkDoneSharp className='text-success' />}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === '2' && (
            <div className='file-upload-container'>
              <label className='btn-upload mb-3'>
                <FiUpload /> Select Files
                <input type='file' accept='application/pdf' multiple onChange={handleSelectFile} style={{ display: 'none' }} />
              </label>

              {/* {uploadedPdf.length > 0 && ( */}
              <div className='uploaded-files'>
                {uploadedFiles.length > 0 && (
                  <div className='section-title d-flex align-items-center gap-2 mb-2'>
                    <HiOutlineDocument className='text-primary' />
                    Uploaded Files
                  </div>
                )}

                {uploadedFiles?.map((file, index) => (
                  <div className='file-upload-item d-flex align-items-center justify-content-between p-3 rounded-3 mb-2' key={index}>
                    <div className='file-name d-flex align-items-center'>
                      <FaRegFilePdf className='me-2' />

                      {file.name}
                    </div>

                    <div className='file-actions d-flex align-items-center gap-3'>
                      <div className='progress' style={{ width: '80px', height: '10px' }}>
                        <div className='progress-bar' style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin='0' aria-valuemax='100'></div>
                      </div>
                      {/* <RiDeleteBin6Line onClick={() => handleUploadedDelete(file.id)} /> */}
                    </div>
                  </div>
                ))}
              </div>
              {/* )} */}
            </div>
          )}

          {(websiteAndPdfs?.pdf_documents?.length > 0 || websiteAndPdfs?.website_urls?.length > 0) && (activeTab === '1' || activeTab === '2') && (
            <div className='comniq-container'>
              <div className='knowledge-hub p-4'>
                <div className='knowledge-hub__header mb-4'>
                  <h5 className='knowledge-hub__title outfit-bold'>Knowledge Sources</h5>
                  <p className='knowledge-hub__subtitle text-muted mb-0 outfit-regular'>Sources that have been added to train your AI chatbot</p>
                  {/* <p className='knowledge-hub__subtitle text-muted mb-0 outfit-regular'>Trained URLs: {websiteAndPdfs?.website_urls_count}</p> */}
                  <p className='knowledge-hub__subtitle text-muted mb-0 outfit-medium'>
                    Training Urls: <span className='outfit-regular'>{websiteAndPdfs?.website_urls_count}</span>
                  </p>
                </div>
                {websiteAndPdfs?.website_urls?.map((url, index) => (
                  <div className='upload-box' key={index}>
                    <div className='d-flex align-items-center gap-3'>
                      <div className='upload-icon-box d-flex align-items-center justify-content-center'>
                        <BiGlobe style={{ color: '#DC5385' }} />
                      </div>
                      <div>
                        <div>
                          <span className='text-decoration-none m-0 outfit-bold text-wrap' title={url.source_name}>
                            {`${url.source_name.length > 100 ? url.source_name.substring(0, 100) + '...' : url.source_name} `}
                          </span>
                        </div>
                        <small className='text-muted'>Created Date: {moment(url?.updatedAt).format('MMMM D, YYYY')}</small>
                      </div>
                    </div>

                    <div className='d-flex align-items-center gap-3'>
                      <span className='knowledge-hub-badge outfit-regular'>TRAINED</span>
                      <div className='delete-icon-box d-flex align-items-center justify-content-center'>
                        <RiDeleteBin6Line
                          // onClick={() => handleUploadedDelete(url.id, 'url')}
                          onClick={() => {
                            setSelectedWebsiteAndPdfs({ id: url.id, type: 'url' });
                            setDeleteWebsiteAndPdfs(true);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
                {websiteAndPdfs?.pdf_documents?.map((file, index) => (
                  <div className='upload-box' key={index}>
                    <div className='d-flex align-items-center gap-3'>
                      <div className='upload-icon-box d-flex align-items-center justify-content-center'>
                        <MdOutlineUploadFile className='' />
                      </div>
                      <div>
                        <div>
                          <a href={file?.url} target='_blank' rel='noopener noreferrer' className='text-decoration-none m-0 outfit-bold text-wrap' title={file.name}>
                            {`${file.name.length > 40 ? file.name.substring(0, 40) + '...' : file.name} `}
                          </a>
                        </div>
                        <small className='text-muted'>Created Date: {moment(file?.upload_at).format('MMMM D, YYYY')}</small>
                      </div>
                    </div>

                    <div className='d-flex align-items-center gap-3'>
                      <span className='knowledge-hub-badge outfit-regular'>TRAINED</span>
                      <div className='delete-icon-box d-flex align-items-center justify-content-center'>
                        <RiDeleteBin6Line
                          // onClick={() => handleUploadedDelete(file.id, 'pdf')}
                          onClick={() => {
                            setSelectedWebsiteAndPdfs({ id: file.id, type: 'pdf' });
                            setDeleteWebsiteAndPdfs(true);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <div className='d-flex justify-content-between align-items-center mt-4'>
                  <button className='btn-delete outfit-medium' onClick={() => setDeleteAllWebsiteAndPdfs(true)}>
                    Clear All
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === '3' && (
            <>
              <div className=''>
                <div className='d-flex justify-content-end align-items-center'>
                  {/* <label className='mb-1 outfit-bold'>Add Text</label> */}
                  <p className='mb-0 outfit-regular font16 text-end'>({countCharacters(addText) || 0} characters)</p>
                </div>
                <textarea
                  placeholder='Enter knowledge text here...'
                  className='addtextbox-textarea outfit-regular'
                  value={addText}
                  rows={10}
                  onChange={(e) => setAddText(e.target.value)}
                />
              </div>
              <button className='chatbot-save-btn d-flex align-items-center gap-2 mt-2 outfit-medium' onClick={() => handleAddText()}>
                Add Knowledge
              </button>
            </>
          )}

          {activeTab === '4' && (
            <div className='knowledge-hub p-4'>
              <div className='knowledge-hub__header mb-4'>
                <h5 className='knowledge-hub__title outfit-bold'>Products and Prices</h5>
                <p className='knowledge-hub__subtitle text-muted mb-0 outfit-regular'>Manage your product pricing to help your chatbot provide accurate rates and information.</p>
              </div>

              <div className='knowledge-hub'>
                <div className='card-body'>
                  <form onSubmit={onFormSubmit} className='chatbox-field'>
                    <div className='mb-4'>
                      <div className='chatbox-input-text input-GPT new'>
                        <div className='d-flex justify-content-between align-items-center'>
                          <label className='mb-1 outfit-medium'>Product Name & Price</label>
                          <p className='mb-0 outfit-regular font14 text-end'>({countCharacters(productPrice) || 0} / 1500)</p>
                        </div>
                        <div className='chatbox-input-field'>
                          <textarea
                            className='form-control chatbox-input textarea-height box-shadow-hover'
                            placeholder='Enter  your product name & price here'
                            id='productPrice'
                            name='productPrice'
                            value={productPrice}
                            autoComplete='off'
                            onChange={(e) => setProductPrice(e.target.value)}
                            maxLength={1500}
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className='d-flex flex-wrap align-items-center justify-content-between'>
                      <button type='submit' className='chatbot-save-btn d-flex align-items-center gap-2' id='firstButton' onClick={companyHandleClick}>
                        <img src={SAVE_ICON} alt='save-icon' /> Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {loader && (
        <div className='loader-center'>
          <Loader />
        </div>
      )}

      {deleteWebsiteAndPdfs && (
        <div className='custom-popup'>
          <div className='popup-content'>
            <div className={'popup-head mt-3 mb-4'}>
              <h4 className='outfit-medium'>Are you sure you want to delete?</h4>
            </div>
            <div className='popup-footer d-flex align-items-center gap-2'>
              <button
                className='btn-modal-save outfit-medium d-flex align-items-center gap-2'
                style={{ background: 'rgb(220, 53, 69)', borderColor: 'rgb(220, 53, 69)' }}
                onClick={() => handleUploadedDelete(selectedWebsiteAndPdfs.id, selectedWebsiteAndPdfs.type)}
              >
                {loader && <ButtonLoader />} <span className='outfit-regular'>Delete</span>
              </button>
              <button className='btn-modal-cancel outfit-medium' data-dismiss='modal' onClick={() => setDeleteWebsiteAndPdfs(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {deleteAllWebsiteAndPdfs && (
        <CustomPopUp
          title='Delete All Website & PDF FAQs?'
          onConfirm={handleDeleteAllWebsiteAndPdfs}
          onClose={() => setDeleteAllWebsiteAndPdfs(false)}
          confirmText='Delete'
          closeText='Cancel'
          variant='error'
          initialWidth='500px'
          loader={loader}
        >
          <p className='outfit-regular'>
            This action will permanently delete all FAQ entries linked to your Website and PDF documents. Once deleted, they cannot be recovered. Are you sure you want to proceed?
          </p>
        </CustomPopUp>
      )}
    </>
  );
};

export default WebsiteScrape;
